type ValueType = [number, number];

// Values in em
export const mobile: ValueType = [0, 46.24];
export const tablet: ValueType = [46.25, 61.24];
export const desktop: ValueType = [61.25, 89.99];
export const wide: ValueType = [90, 119.99];
export const ultra: ValueType = [120, 999];
